export default __webpack_public_path__ + "static/media/classCompParent.104aa567.png";